import React from "react";
import { useEffect, useState } from "react";

function getProfileData() {
    return localStorage.getItem('userName');
}

export default function useProfileData() {
    const [profile, setProfile] = useState(getProfileData());

    useEffect(() => {
        function handleChangeStorage() {
            setProfile(getProfileData());
        }

        window.addEventListener('storage', handleChangeStorage);
        return () => window.removeEventListener('storage', handleChangeStorage);
    }, []);

    return profile;
}
